import React from "react";
import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { panelCardSx } from "../../theme/surfaceStyles";

export default function GlowCard({
    title,
    subtitle,
    icon: Icon,
    action,
    children,
    hover = false,
    sx,
}) {
    return (
        <Card sx={(theme) => ({ ...panelCardSx(theme, { hover }), ...(typeof sx === "function" ? sx(theme) : sx) })}>
            <CardContent sx={{ py: 2, px: 2.25, "&:last-child": { pb: 2 } }}>
                {title || subtitle || action ? (
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={2}
                        sx={{ mb: children ? 1.75 : 0 }}
                    >
                        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ minWidth: 0 }}>
                            {Icon ? <Icon sx={{ fontSize: 20, color: "primary.main", opacity: 0.85 }} /> : null}
                            <Box sx={{ minWidth: 0 }}>
                                {title ? (
                                    <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
                                        {title}
                                    </Typography>
                                ) : null}
                                {subtitle ? (
                                    <Typography variant="caption" color="text.secondary" display="block">
                                        {subtitle}
                                    </Typography>
                                ) : null}
                            </Box>
                        </Stack>
                        {action}
                    </Stack>
                ) : null}
                {children}
            </CardContent>
        </Card>
    );
}
